import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default class ToolsAndResources {
  constructor(container) {
    if (!container) return

    this.DOM = {
      container,
      toolsAndRessourcesType: container.querySelector('#toolsAndRessourcesType'),
      toolsAndRessourcesArea: container.querySelector('#toolsAndRessourcesArea'),
      results: container.querySelector('.tools-and-ressources--results'),
    }

    this.init()
  }

  init() {
    const {
      container = null,
      toolsAndRessourcesType = null,
      toolsAndRessourcesArea = null,
      results,
    } = this.DOM

    if (!toolsAndRessourcesType || !toolsAndRessourcesArea || !results) return

    this.tool_ressource_type_term = '';
    this.tipping_point_cpt = '';
    this.urlajax = container.dataset.ajaxurl;

    toolsAndRessourcesType.addEventListener('change', (e) => {
      this.tool_ressource_type_term = e.target.value
      this.runSearch()
    })

    toolsAndRessourcesArea.addEventListener('change', (e) => {
      this.tipping_point_cpt = e.target.value
      this.runSearch()
    })

    this.runSearch()
  }

  onSuccess(responseText) {
    const json = JSON.parse(responseText);

    const currentListPosts = this.DOM.results;
    currentListPosts.innerHTML = json.listPosts_html;

    ScrollTrigger.refresh()
  }

  runSearch() {
    const formData = new FormData();
    formData.append('tool_ressource_type_term', this.tool_ressource_type_term);
    formData.append('tipping_point_cpt', this.tipping_point_cpt);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', this.urlajax, true);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        switch (xhr.status) {
          case 200:
            this.onSuccess(xhr.responseText)
            break
          case 422:
            break
          default:
//            this.onServerError()
        }
      }
    }
    xhr.send(formData)
  }

  destroy() {

  }
}